import { BigDecimal } from "@pcgerente-node/pcg-comun";
import { TIPO_IVA, logistica_CONTENIDO } from "@pcgerente-node/pcg-comun/dist/DTOs";

export class RowContenidoviewModel {
    public cantidad: BigDecimal = new BigDecimal(0)
    public BaseIva: BigDecimal= new BigDecimal(0)
    public BaseCero: BigDecimal = new BigDecimal(0)
    public total: BigDecimal = new BigDecimal(0)
    public subtotal: BigDecimal = new BigDecimal(0)
    public iva: BigDecimal = new BigDecimal(0)
    public seguro: boolean = false
    public precio: BigDecimal = new BigDecimal(0)
    public bultos: number = 0;
    public descripcion: string = ""
    public detalles: string = ""
    public idContenido: number = 0
    public TIPO_IVA: TIPO_IVA = new TIPO_IVA() 

    constructor(contenido?: logistica_CONTENIDO){
        if(contenido){
            this.descripcion = contenido.descripcion
            this.idContenido = contenido.id
            this.precio = new BigDecimal(contenido.precio)
            if(contenido.TIPO_IVA){
                this.TIPO_IVA = contenido.TIPO_IVA
            }else{
                throw new Error(`No se ha podido obtener la relación con TIPO_IVA del contenido ${this.descripcion}`)
            }
            if(this.descripcion === "*SEGURO*"){
                this.seguro = true
            }
        }
    }
}

